import request from '@/utils/request'

const base = "/internal-auth";
//获取钉钉authCode后登录
export function realLogin(authCode) {
  let headers ={
    Authorization:authCode,
    'login-type':'ding_ding',
  };
  if(process.env.NODE_ENV != "production" && process.env.VUE_APP_BUILD != '1'){
    headers['X-Forwarded-Host'] = 'bestway.dev.com';
  }
  return request({
    url: `${base}/login`,
    method: 'post',
    headers:{
      ...headers
    },
  })
}

export function userInfo(data) {
  return request({
    url: `${base}/getUserInfoByToken`,
    method: 'post',
    data: data
  })
}

export function getVerificationCode() {
  return request({
    url: '/security/obtain-graph-captcha',
    method: 'get'
  })
}

export function login (data) {
  return request({
    url: '/login.json',
    // url: '/login/username_password',
    method: 'post',
    data: data
  })
}

export function getMenu(data) {
  return request({
    // url: '/menu.json',
    url: `${base}/menu/queryAccessibleMenus`,
    method: 'post',
    data
  })
}

/** 获取验证码
 *	@param { Object } data					-参数
 * 	@tutorial http://192.168.2.230:19000/project/53/interface/api/6877
 */
export function getCaptcha(params) {
  return request({
    url: `${base}/obtain-graph-captcha`,
    method: 'get',
    params
  })
}

/** 经销商登陆
 *	@param { Object } data					-参数
 * 	@tutorial http://192.168.2.230:19000/project/53/interface/api/6876
 */
export function dealerLogin(params) {
  return request({
    url: `${base}/login`,
    method: 'post',
    headers: {
      ...params,
      isWithoutToken: true
    },
  })
}

/** 重置密码
 *	@param { Object } data					-参数
 * 	@tutorial http://192.168.2.230:19000/project/53/interface/api/8397
 */
export function resetPassword(data) {
  return request({
    url: `/bestway/dealerLogin/resetPassword`,
    method: 'post',
    data
  })
}


